import { useQuery } from '@tanstack/react-query';
import { QUERY_KEYS } from '@/constants';
import { isLimitedAdminScope } from '@/helpers';
import { useGlobalSettings } from '@/hooks/useGlobalSettings';
import ChurchesService from '@/services/churches.service';

export const useChurch = (id: string | undefined) => {
  const { currentChurch } = useGlobalSettings();
  const isLimitedScope = isLimitedAdminScope({
    isLimitedScope: currentChurch?.isLimitedScope,
    isGroupScope: currentChurch?.isGroupScope,
  });

  return useQuery({
    queryKey: [QUERY_KEYS.CHURCH_BASE_QUERY_KEY, QUERY_KEYS.CHURCH, id],
    queryFn: () => ChurchesService.getChurchById(id || ''),
    staleTime: 1000 * 60 * 5,
    enabled: Boolean(id) && !isLimitedScope,
  });
};
